import { FC } from 'react';
import AreaServiceSelect from './AreaServiceSelect';
import UseAreaServiceSelect from './UseAreaServiceSelect';

const AreaServiceSelectContainer: FC = () => {
  return <AreaServiceSelect {...UseAreaServiceSelect()} />;
};

export default AreaServiceSelectContainer;
